import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Brain } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";

export default function AiModelCard({ canEdit }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/ai").then((r) => setData(r.data)).catch(() => {}); }, []);

  const choose = async (provider) => {
    if (!canEdit || busy || provider === data?.provider) return;
    setBusy(true);
    try {
      const { data: d } = await api.put("/settings/ai", { provider });
      setData((s) => ({ ...s, ...d }));
      toast.success(`Yapay zekâ modeli: ${d.label}`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  if (!data) return null;
  return (
    <div className="panel fade-up p-6" data-testid="ai-model-card">
      <h3 className="flex items-center gap-2 font-display text-lg font-bold"><Brain size={18} /> Yapay Zekâ Modeli</h3>
      <p className="mt-1 text-xs text-muted-foreground">Yapay zekâ raporları ve fiş fotoğrafı okuma bu modelle çalışır. Emergent anahtarıyla ek hesap gerekmez.</p>
      <div className="mt-4 grid gap-2 sm:grid-cols-2">
        {data.options.map((o) => (
          <button key={o.id} type="button" disabled={!canEdit || busy} onClick={() => choose(o.id)} data-testid={`ai-provider-${o.id}`}
            className={`border p-3 text-left text-sm transition-colors ${data.provider === o.id ? "border-teal-600 bg-teal-50 font-semibold text-teal-900" : "border-border hover:bg-muted disabled:opacity-60"}`}>
            {o.label}{data.provider === o.id && <span className="ml-2 text-[10px] uppercase tracking-wider text-teal-700">Seçili</span>}
          </button>
        ))}
      </div>
      {!canEdit && <p className="mt-2 text-[11px] text-muted-foreground">Yalnızca işveren değiştirebilir.</p>}
    </div>
  );
}
